module.exports = __webpack_public_path__ + "static/media/cozy9207.b32a0398.jpg";